import React from 'react';
import {useForm} from 'react-hook-form';
import {Box, Flex, FormLabel, Input, Stack} from '@chakra-ui/core';
import {Button} from 'components/Button';
import {useStateMachine} from 'little-state-machine';
import {clearForm} from 'store';
import {parseNumber} from 'utils/fields';
import sleipnerLogo from 'assets/logo.svg';
import {darkgrey, yellow} from 'styles/constants';

export const Step1 = (props) => {
	const {register, handleSubmit} = useForm({
		defaultValues: {},
	});
	const {actions} = useStateMachine({clearForm});
	const {setWeight, setCurrentView} = props;

	const onSubmit = (data) => {
		if (!data.excavator_operating_weight) return;

		setWeight(data.excavator_operating_weight);

		// Reset form values for default values to load correctly in the next step
		actions.clearForm();

		setCurrentView(2);
	};

	return (
		<Stack alignItems={'center'} mt={24}>
			<Box pb={4}>
				<img src={sleipnerLogo} alt="Sleipner" width={'120px'} />
			</Box>

			<Box
				bg={yellow}
				w="100%"
				p={8}
				color={darkgrey}
				maxW={'md'}
				margin="auto"
				rounded={2}
			>
				<form onSubmit={handleSubmit(onSubmit)}>
					<FormLabel>Excavator operating weight in tonnes</FormLabel>
					<Input
						{...register('excavator_operating_weight', {
							required: 'Required',
							max: '575',
							min: '1',
							setValueAs: parseNumber,
						})}
						placeholder="Max 570"
						_placeholder={{color: '#333'}}
						type="number"
						color={darkgrey}
					/>
					<br />

					<Flex justifyContent="center">
						<Button type="submit" w={{base: 80, md: 100}}>
							Continue
						</Button>
					</Flex>
				</form>
			</Box>
		</Stack>
	);
};
